import CustomContextPadProvider from './CustomContextPadProvider';

export default {
  __init__: ['contextPadProvider'],
  contextPadProvider: ['type', CustomContextPadProvider],
};
